import { ExclamationCircleFilled } from '@ant-design/icons';
import { Tooltip } from 'antd';
import styled from 'styled-components';

import { FareType } from '../../../typesFinancial';

const billableStatuses = ['BILLING', 'REVERSED', 'SEND_ERROR'];

const missingRevenueCodeHint =
  'Sem o código de despesa/receita, o envio ao RM é recusado.';

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 8px;
  row-gap: 2px;
  min-width: 0;
  font-size: 13px;
  line-height: 20px;

  .revenue-code-number {
    padding: 0 6px;
    border: 1px solid var(--neutral_lighter);
    border-radius: 4px;
    background: var(--neutral_lightest);
    color: var(--ocean_dark);
    font-family: Consolas;
    font-weight: 700;
    white-space: nowrap;
  }

  .revenue-code-description {
    color: var(--neutral_dark);
    overflow-wrap: anywhere;
  }

  .revenue-code-missing {
    color: var(--neutral_medium);
  }

  .revenue-code-missing.pending {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: var(--error-medium);
    font-weight: 600;
  }
`;

export function isMissingBillableRevenueCode(fare: FareType) {
  return (
    !fare.revenue_code &&
    !fare.is_exempt &&
    billableStatuses.includes(fare.status || 'BILLING')
  );
}

function PendingRevenueCode({ label }: { label: string }) {
  return (
    <Tooltip title={missingRevenueCodeHint}>
      <span className="revenue-code-missing pending">
        <ExclamationCircleFilled />
        {label}
      </span>
    </Tooltip>
  );
}

export function MissingRevenueCodeAlert({ fare }: { fare: FareType }) {
  if (!isMissingBillableRevenueCode(fare)) {
    return null;
  }

  return (
    <Container>
      <PendingRevenueCode label="Sem despesa/receita" />
    </Container>
  );
}

export function FareRevenueCode({ fare }: { fare: FareType }) {
  if (fare.revenue_code) {
    return (
      <Container>
        <span className="revenue-code-number">{fare.revenue_code.code}</span>
        <span className="revenue-code-description">
          {fare.revenue_code.description}
        </span>
      </Container>
    );
  }

  return (
    <Container>
      {isMissingBillableRevenueCode(fare) ? (
        <PendingRevenueCode label="Não informada" />
      ) : (
        <span className="revenue-code-missing">Não informada</span>
      )}
    </Container>
  );
}
